import moment from "moment";
import UploadDoc from "../assets/UploadDoc";

export const getInitials = (name) => {
  if (typeof name !== "string" || !name.trim()) return null;

  const nameParts = name.trim().split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  } else {
    return nameParts[0][0].toUpperCase();
  }
};


export const qs = (params) => {
  if (!params || typeof params !== "object") return "";
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${queryString}` : "";
};

export const formatDate = (date, format = "DD-MM-YYYY, hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};

export const formatePrice = (number) => {
  if (!number) return "$ 0";
  const formattedNumber = Number(Math.abs(number)).toFixed(2);
  return `$ ${formattedNumber}`
};

export const getFilenameFromContentDisposition = (
  contentDisposition,
  fallback = "download.xlsx",
) => {
  if (!contentDisposition) return fallback;

  const utf8Match = contentDisposition.match(
    /filename\*\s*=\s*UTF-8''([^;\n]+)/i,
  );
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^["']|["']$/g, ""));
    } catch (error) {
      return utf8Match[1].trim().replace(/^["']|["']$/g, "");
    }
  }

  const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i);
  if (quotedMatch?.[1]) {
    return quotedMatch[1].trim();
  }

  const plainMatch = contentDisposition.match(/filename\s*=\s*([^;\n]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim().replace(/^["']|["']$/g, "");
  }

  return fallback;
};

// Browsers truncate <a download> filenames at "@", which also drops the extension.
export const sanitizeExcelDownloadFilename = (fileName) => {
  let name = String(fileName || "download").trim();
  name = name.replace(/@/g, "_at_");
  name = name.replace(/[\\/:*?"<>|]+/g, "_");
  if (!/\.xlsx$/i.test(name)) {
    name = `${name.replace(/\.+$/, "")}.xlsx`;
  }
  return name;
};

export const getDownloadFilenameFromResponse = (response, fallback) => {
  const headers = response?.headers;
  let contentDisposition = "";

  if (headers) {
    if (typeof headers.get === "function") {
      contentDisposition =
        headers.get("content-disposition") ||
        headers.get("Content-Disposition") ||
        "";
    }

    if (!contentDisposition) {
      const matched = Object.entries(headers).find(
        ([key]) => String(key).toLowerCase() === "content-disposition",
      );
      contentDisposition = matched?.[1] || "";
    }
  }

  return sanitizeExcelDownloadFilename(
    getFilenameFromContentDisposition(contentDisposition, fallback),
  );
};

export const getIBHierarchyReportFallbackName = ({
  salesAgentEmail,
  email,
} = {}) => {
  if (salesAgentEmail) {
    return `IB_Hierarchy_Commission_Lots_SalesAgent_${salesAgentEmail}`;
  }
  if (email) {
    return `IB_Hierarchy_Commission_Lots_${email}`;
  }
  return "IB_Hierarchy_Commission_Lots";
};

export const getIBDealCommissionReportFallbackName = ({ email } = {}) => {
  if (email) {
    return `IB_Deal_Commission_${email}`;
  }
  return "IB_Deal_Commission";
};

export const mobileNumberValidator = () => ({
  validator(_, value) {
    if (!value) {
      return Promise.reject("Phone number required");
    }
    if (!/^\d+$/.test(value)) {
      return Promise.reject("Only numbers are allowed");
    }
    if (value.length < 8 || value.length > 15) {
      return Promise.reject("Mobile number must be between 8 and 15 digits");
    }
    return Promise.resolve();
  },
});

export const ownershipPercentageValidator = () => ({
  validator(_, value) {
    if (value === undefined || value === null || value === "") {
      return Promise.reject("Please enter ownership percentage");
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
      return Promise.reject("Please enter a valid number");
    }
    if (num < 0) {
      return Promise.reject("Value cannot be less than 0");
    }
    if (num > 100) {
      return Promise.reject("Value cannot be more than 100");
    }
    return Promise.resolve();
  },
});

export const AlternativeMobileNumberValidator = () => ({
  validator(_, value) {
    if (!value) {
      return Promise.resolve();
    }
    if (!/^\d+$/.test(value)) {
      return Promise.reject("Only numbers are allowed");
    }
    if (value.length < 8 || value.length > 15) {
      return Promise.reject("Mobile number must be between 8 and 15 digits");
    }
    return Promise.resolve();
  },
});

export const DocumentUploadButton = (
  <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
    <div className="flex justify-center w-auto mb-5 px-4 py-4 bg-gray-100 rounded-md pointer-events-none opacity-75">
      <UploadDoc color="#7367F0" />
    </div>
    <div className="text-base font-medium capitalize mb-1 pointer-events-none text-gray-500">
      Upload Company Document
    </div>
    <div className="text-gray-400">
      Drag and drop your files here or{" "}
      <span className="text-[#7367F0] cursor-pointer">Click to Select</span>
    </div>
    <div className="text-gray-400">
      Supported Formats: .jpg, .jpeg, .png, .pdf, .doc, .docx
    </div>
  </div>
);
